import {Injectable} from '@angular/core';
import {HttpRepository} from './http.repository';
import {GlobalConfig} from '../configs/GlobalConfig';
import {PagingRequest} from '../interfaces/rest/paging/PagingRequest';
import {PagedData} from "../interfaces/rest/paging/PagedData";
import {Observable} from "rxjs";
import {AlertDataResponse} from "../interfaces/rest/AlertDataResponse";

@Injectable()
export class AlertRuleHistoryRepository {

  constructor(protected httpRepository: HttpRepository) {

  }

  getAlertRuleHistoryForSelectedClient(client: number, startDatetimeMillis: Date, endDatetimeMillis: Date) {
    let bodydata = {
      'alertRuleList': [],
      'startDate': startDatetimeMillis,
      'endDate': endDatetimeMillis,
      'clientId': client
    };
    let body: string = JSON.stringify(bodydata);
    return this.httpRepository.post(GlobalConfig.dataApiEndpoints.alertData + '/getAlertRuleHistoryByClientId', body);
  }


  getAlertRuleHistoryWithPaging(pagingRequest: PagingRequest): Observable<PagedData> {
    return this.httpRepository.post(`${GlobalConfig.dataApiEndpoints.alertData}/getAlertRuleHistory/paging`, pagingRequest);
  }


  // getAlertRuleHistoryPaging (pagingRequest: PagingRequest){
  //   return this.httpRepository.post(`${GlobalConfig.dataApiEndpoints.alertData}`, pagingRequest);
  // }

  getAlertRuleSummaryWithPaging(pagingRequest: PagingRequest): Observable<PagedData> {
    return this.httpRepository.post(`${GlobalConfig.dataApiEndpoints.alertData}/getAlertRuleSummary/paging`, pagingRequest);
  }

  getAlertInstance(alertInstanceId: string|number): Observable<AlertDataResponse> {
    return this.httpRepository.get(`${GlobalConfig.dataApiEndpoints.alertData}/alertInstanceID/${alertInstanceId}`);
  }
}
